import { useState } from "react";
import { Plus, FileText, Sparkles, TrendingUp, Upload, FileUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { NewSettlementDialog } from "./NewSettlementDialog";
import { AgreementWizard } from "./AgreementWizard";
import { UploadAgreementDialog } from "./UploadAgreementDialog";
import { EmissionUploadDialog } from "./EmissionUploadDialog";

export function NewTransactionMenu({ companyId, rows, classes, onChanged, canEdit = true }) {
  const [settlementOpen, setSettlementOpen] = useState(false);
  const [wizard, setWizard] = useState(null);
  const [uploadOpen, setUploadOpen] = useState(false);
  const [emissionOpen, setEmissionOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button className="gap-2 active:scale-[0.98]" data-testid="new-transaction-btn"><Plus className="h-4 w-4" /> Kjøp / salg</Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-64">
          <DropdownMenuLabel>Velg type transaksjon</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem className="gap-2.5 py-2.5" data-testid="tx-type-enkel" onClick={() => setSettlementOpen(true)}>
            <FileText className="h-4 w-4 text-primary" />
            <div><p className="text-sm font-medium">Enkel sluttseddel</p><p className="text-xs text-muted-foreground">Rett kjøp/salg mellom to parter</p></div>
          </DropdownMenuItem>
          <DropdownMenuItem className="gap-2.5 py-2.5" data-testid="tx-type-kompleks" onClick={() => setWizard("kompleks_salg")}>
            <Sparkles className="h-4 w-4 text-primary" />
            <div><p className="text-sm font-medium">Kompleks salg (SPA)</p><p className="text-xs text-muted-foreground">AI-veiviser lager en aksjekjøpsavtale</p></div>
          </DropdownMenuItem>
          <DropdownMenuItem className="gap-2.5 py-2.5" data-testid="tx-type-emisjon" onClick={() => setWizard("emisjon")}>
            <TrendingUp className="h-4 w-4 text-primary" />
            <div><p className="text-sm font-medium">Emisjon (AI-veiviser)</p><p className="text-xs text-muted-foreground">Utsted nye aksjer med AI-vedtak og signering</p></div>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem className="gap-2.5 py-2.5" data-testid="tx-type-upload" onClick={() => setUploadOpen(true)}>
            <Upload className="h-4 w-4 text-primary" />
            <div><p className="text-sm font-medium">Last opp ferdig avtale/sluttseddel</p><p className="text-xs text-muted-foreground">Murphy godkjenner og registrerer</p></div>
          </DropdownMenuItem>
          {canEdit ? (
            <DropdownMenuItem className="gap-2.5 py-2.5" data-testid="tx-type-emisjon-manual" onClick={() => setEmissionOpen(true)}>
              <FileUp className="h-4 w-4 text-primary" />
              <div><p className="text-sm font-medium">Manuell emisjon (last opp papirer)</p><p className="text-xs text-muted-foreground">Fyll inn alt selv – Murphy godkjenner</p></div>
            </DropdownMenuItem>
          ) : null}
        </DropdownMenuContent>
      </DropdownMenu>

      <NewSettlementDialog companyId={companyId} rows={rows} onGenerated={onChanged} open={settlementOpen} onOpenChange={setSettlementOpen} showTrigger={false} />
      {wizard ? (
        <AgreementWizard companyId={companyId} rows={rows} classes={classes} kind={wizard} open={!!wizard} onOpenChange={(o) => { if (!o) setWizard(null); }} onCreated={onChanged} />
      ) : null}
      <UploadAgreementDialog companyId={companyId} rows={rows} classes={classes} open={uploadOpen} onOpenChange={setUploadOpen} onUploaded={onChanged} />
      <EmissionUploadDialog companyId={companyId} classes={classes} open={emissionOpen} onOpenChange={setEmissionOpen} onUploaded={onChanged} />
    </>
  );
}
